// Centralised translations DE / EN

export const translations = {
  de: {
    nav: {
      women: "Frauen",
      men: "Männer",
      contact: "Kontakt",
      imprint: "Impressum",
      privacy: "Datenschutz",
      backHome: "Zurück zur Auswahl",
    },
    entry: {
      eyebrow: "Enrico Müller & Colleen Schmidt · Coaching",
      question: "Welchen Weg gehen wir gemeinsam?",
      lead: "Wähle deinen Bereich für maßgeschneidertes Coaching.",
      women: {
        eyebrow: "Mit Colleen",
        title: "Innere Reise.",
        subtitle: "Klarheit. Weibliche Kraft.",
        action: "Diesen Weg gehen",
      },
      men: {
        eyebrow: "Mit Enrico",
        title: "Mentale Stärke.",
        subtitle: "Fokus. Souveränität.",
        action: "Diesen Weg gehen",
      },
      footer: "Diskretes Erstgespräch · Hypnose · Körpersprache · Selbstentfaltung",
    },
    stage: {
      eyebrow: "Enrico Müller & Colleen Schmidt",
      brand: "Green Horizon Life",
      question: "Wer soll wachsen — du oder dein Team?",
      lead: "Eine Reise. Zwei Welten. Wähle deinen Weg und entdecke, was sich bei dir verändern darf.",
      privat: {
        eyebrow: "Privat",
        title: "Für dich persönlich.",
        subtitle: "Innere Klarheit, Wachstum, Selbstentfaltung.",
        body: "Hypnose, Körpersprache, systemische Aufstellung — für deinen ganz persönlichen Weg.",
        action: "Privater Weg",
      },
      business: {
        eyebrow: "Geschäftlich",
        title: "Für dein Unternehmen.",
        subtitle: "Workshops, Team-Coaching, Verkaufstraining.",
        body: "Mental starke Teams, souveräne Führung, klare Verkaufsabschlüsse — für Unternehmen und Organisationen.",
        action: "Geschäftlicher Weg",
      },
      footer: "Zwei Coaches · Eine Vision · Echtes Wachstum",
    },
    women: {
      hero: {
        eyebrow: "Mit Colleen Schmidt · Systemische Beratung, Aufstellungen & Spiritualität",
        title: "Entdecke dein wahres Ich.",
        sub: "Bist du bereit für eine Reise zu dir selbst? Gemeinsam lösen wir Blockaden, heilen alte Verletzungen und stärken die Verbindung zu deinem inneren Kind. Schritt für Schritt findest du zurück zu deiner Stärke, deiner Energie und den tiefsten Wünschen deines Herzens.",
        ctaPrimary: "Erstgespräch anfragen",
        ctaSecondary: "Mehr erfahren",
      },
      problem: {
        eyebrow: "Wenn du dich wiedererkennst",
        title: "Du funktionierst, doch innerlich fühlt sich etwas eng an.",
        body: "Belastende Familienmuster, alte Ängste, leise Glaubenssätze — sie halten dich klein, obwohl du nach außen alles erfüllst. Wenn du bereit bist, dich selbst anzunehmen und dein Leben bewusst zu gestalten, beginnt hier deine Reise. Dein neues Leben wartet auf dich.",
        bullets: [
          "Ängste, die immer wieder hochkommen.",
          "Familiäre Muster, die sich wiederholen.",
          "Ein leises Gefühl, dass mehr in dir steckt.",
          "Die Sehnsucht nach Klarheit und Verbindung.",
        ],
      },
      about: {
        eyebrow: "Über Colleen",
        title: "Begleitung mit Tiefe, Achtsamkeit und Klarheit.",
        body: "Mit systemischer Beratung, Aufstellungsarbeit, Achtsamkeit, Meditation und spirituellen Impulsen begleite ich dich dabei, wieder in Verbindung mit dir selbst zu kommen und dein volles Potenzial zu entfalten. Ich begleite dich dabei, belastende Familienmuster loszulassen, neue Klarheit zu gewinnen und deine innere Kraft wiederzuentdecken.",
        quote: "Dein Weg beginnt mit dem ersten Schritt – hin zu einem Leben im Einklang mit deinem Herzen.",
      },
      pillars: {
        eyebrow: "Mögliche Themen",
        title: "Themen unserer gemeinsamen Arbeit.",
        items: [
          {
            id: "blockaden",
            title: "Blockaden & Glaubenssätze",
            body: "Wir erkennen und lösen alte Glaubenssätze, durchbrechen festgefahrene Muster und schaffen Raum für neue Klarheit.",
          },
          {
            id: "aufstellung",
            title: "Systemische Aufstellungen",
            body: "Familiäre Verstrickungen, Beziehungen und Lebensthemen werden sichtbar – und können dadurch in Bewegung kommen.",
          },
          {
            id: "inneres-kind",
            title: "Inneres Kind & Spiritualität",
            body: "Heile alte Verletzungen, stärke dein inneres Kind und vertiefe deine Intuition durch Meditation und spirituelle Impulse.",
          },
        ],
      },
      proof: {
        eyebrow: "Was Klientinnen erleben",
        items: [
          "Nach unserer Aufstellung war plötzlich klar, was mich jahrelang gebunden hatte. Ich fühle mich endlich frei.",
          "Colleen schafft einen Raum, in dem ich wirklich ankommen konnte. Tief, ruhig, ohne Druck.",
          "Mein inneres Kind durfte zum ersten Mal Raum nehmen. Das hat alles verändert.",
        ],
      },
      cta: {
        eyebrow: "Nächster Schritt",
        title: "Beginne deine Reise.",
        sub: "Vereinbare jetzt dein vertrauliches Erstgespräch. Ruhig, ohne Druck, ohne Verpflichtung — ein klarer Raum für deine Themen.",
        formTitle: "Vertrauliches Erstgespräch anfragen",
        investmentNote: "Investition und Umfang besprechen wir individuell im vertraulichen Erstgespräch.",
      },
      bridge: {
        eyebrow: "Andere Wege",
        title: "Suchst du etwas anderes?",
        body: "Mein Partner Enrico Müller arbeitet mit Männern an mentaler Stärke, Körpersprache und Macher-Motivation. Für Unternehmen bieten wir gemeinsam Workshops, Team-Coaching und Verkaufstraining an.",
        crossEyebrow: "Du suchst den fordernden, fokussierten Ansatz?",
        crossLink: "Zur Männer-Seite wechseln",
      },
      shop: {
        eyebrow: "Begleitung für zwischendurch",
        title: "Meditationen, PDFs & mehr",
        sub: "Meditationen, PDF-Begleiter und Aufstellungs-Anleitungen zum Nachhören und Üben. Direkt nach dem Kauf herunterladbar.",
      },
    },
    men: {
      hero: {
        eyebrow: "Für Männer. Hypnose, Körpersprache & Macher-Motivation",
        title: "Mentale Stärke. Voller Fokus. Absolute Präsenz.",
        sub: "Durchbrich die Denkmuster, die dich blockieren. Nutze die Kraft von Hypnose und messerscharfer Körpersprache, um als Mann deine volle Stärke und Souveränität zurückzuholen.",
        ctaPrimary: "Erstgespräch sichern",
        ctaSecondary: "Wie es läuft",
      },
      problem: {
        eyebrow: "Erkennst du dich wieder?",
        title: "Du funktionierst, aber du stagnierst.",
        body: "Außen läuft es. Zahlen, Zuständigkeiten, Termine. Trotzdem dieses Gefühl: Gedankenkreisen statt klarer Entscheidung. Motivation, die im Verkauf wegrutscht. Präsenz, die im Meeting nicht mehr unerschütterlich ist. Du weißt, du kannst mehr, du kommst nur nicht ran.",
        bullets: [
          "Kopf voll, Entscheidungen zäh.",
          "Verkaufsgespräche, die nicht mehr ziehen.",
          "Dein Auftreten wirkt, aber nicht so klar wie du willst.",
          "Du brauchst keinen Pep-Talk. Du brauchst Veränderung im Unterbewusstsein.",
        ],
      },
      about: {
        eyebrow: "Über mich",
        title: "Vom Druckkochtopf der Profiküche in die mentale Hochleistungszone.",
        body: "Als gelernter Koch habe ich in Hochleistungs-Küchen gelernt, was Fokus, Hitze und Klarheit wirklich bedeuten. Meinen Verkaufs-Skill habe ich international geschärft, unter anderem in intensiven Trainings in Italien, wo Verkauf nicht gelehrt, sondern gelebt wird. Aus dieser Praxis weiß ich genau, was Männer im Vertrieb und im Auftreten wirklich blockiert. Und durch meine eigene, krasse Entwicklung weiß ich, wie man mentale Blockaden direkt im Unterbewusstsein zerschlägt. Präzise, ohne Schnörkel.",
        quote: "Du musst nicht härter werden. Du musst klarer werden.",
      },
      pillars: {
        eyebrow: "Drei Säulen",
        title: "Drei Hebel. Sofort spürbar.",
        items: [
          {
            id: "hypnose",
            title: "Männer-Hypnose",
            body: "Blockaden eliminieren, direkt im Unterbewusstsein. Glaubenssätze, die dich klein halten, werden präzise abgebaut und durch neue Programmierung ersetzt.",
          },
          {
            id: "koerper",
            title: "Maskuline Körpersprache",
            body: "Dominanz & Souveränität, die nicht aufgesetzt ist. Stand, Stimme, Blick. Im Verkaufsgespräch, im Meeting, im Raum, überall.",
          },
          {
            id: "motivation",
            title: "Macher-Motivation",
            body: "Fokus & Verkaufstraining auf Profi-Niveau. Du gehst raus mit klaren Zielen, klaren Sätzen und einem mentalen Setup, das hält.",
          },
        ],
      },
      proof: {
        eyebrow: "Was Klienten berichten",
        items: [
          "Nach drei Sitzungen war das, was mich seit zwei Jahren blockiert hat, einfach nicht mehr da.",
          "Meine Closing-Rate ist hoch gegangen. Aber das Wichtigste: Ich stehe wieder voll im Raum.",
          "Kein Bla. Klar, präzise, wirkungsvoll. Genau das, was ich brauchte.",
        ],
      },
      cta: {
        eyebrow: "Nächster Schritt",
        title: "Jetzt Erstgespräch sichern.",
        sub: "Raus aus dem Kopf, rein in den Erfolg. Wir sprechen 30 Minuten, klar, direkt, ohne Verkaufsdruck. Du gehst mit einem konkreten nächsten Schritt raus.",
        formTitle: "Erstgespräch anfragen",
        investmentNote: "Investition und Umfang besprechen wir individuell im Erstgespräch.",
      },
      shop: {
        eyebrow: "Werkzeuge",
        title: "Direkt einsetzbar. Sofort wirksam.",
        sub: "Audio-Sessions, PDFs und Videos, die zwischen unseren Gesprächen weiterarbeiten. Sofortiger Download nach Bezahlung.",
      },
      bridge: {
        eyebrow: "Auch Tiefe & Emotion",
        title: "Die stärksten Männer sind die, die beides können.",
        body: "Mentale Stärke heißt nicht, ohne Emotion zu sein. Echte Souveränität entsteht, wenn du auch Tiefenentspannung, Selbstreflexion und emotionale Klarheit beherrschst, nicht nur Performance. Wer im Inneren stabil ist, dominiert im Außen ruhiger und nachhaltiger.",
        crossEyebrow: "Du suchst den ruhigeren, tieferen Zugang?",
        crossLink: "Zur Frauen-Seite wechseln",
      },
    },
    business: {
      hero: {
        eyebrow: "Für Unternehmen · Workshops, Team-Coaching & Verkaufstraining",
        title: "Mentale Stärke. Klare Kommunikation. Spürbare Ergebnisse.",
        sub: "Gemeinsam unterstützen Enrico Müller & Colleen Schmidt Unternehmen und Teams dabei, mental belastbar, kommunikativ präzise und souverän im Auftritt zu werden — drinnen wie draußen.",
        ctaPrimary: "Unverbindlich anfragen",
        ctaSecondary: "Leistungen ansehen",
      },
      offers: {
        eyebrow: "Leistungen",
        title: "Was wir für Unternehmen anbieten.",
        items: [
          { id: "workshops", title: "Firmen-Workshops", body: "Hypnose-, Körpersprache- und Mindset-Workshops für Mitarbeitende. Inhouse, kompakt, mit messbaren Ergebnissen." },
          { id: "team", title: "Team-Coaching & Führung", body: "Coaching für Führungskräfte und ganze Teams: Klarheit in der Kommunikation, Konfliktarbeit, souveräne Präsenz." },
          { id: "stress", title: "Resilienz & Stress-Prävention", body: "Mentale Belastbarkeit, Tiefenentspannung und Achtsamkeit für Mitarbeitende — beugt Ausfällen vor, hebt Performance." },
          { id: "verkauf", title: "B2B-Verkaufstraining", body: "Verkauf auf Profi-Niveau: Gesprächsführung, Abschlusstechniken, Körpersprache im Verkaufsgespräch." },
          { id: "retreats", title: "Retreats für Unternehmer", body: "Mehrtägige spirituelle Retreats für Selbstständige, Gründer und Führungspersönlichkeiten." },
          { id: "aufstellung", title: "Systemische Aufstellungen im Business-Kontext", body: "Strategische Klarheit über Strukturen, Rollen und Konflikte durch Aufstellungsarbeit." },
        ],
      },
      duo: {
        eyebrow: "Eure Coaches",
        title: "Enrico Müller & Colleen Schmidt — komplementäre Stärken.",
        body: "Enrico bringt mentale Klarheit, Körpersprache und Hochleistungs-Mindset. Colleen ergänzt um systemische Tiefe, Aufstellungsarbeit und emotionale Intelligenz. Gemeinsam decken wir die ganze Bandbreite ab — von Performance bis Persönlichkeit.",
      },
      cta: {
        eyebrow: "Nächster Schritt",
        title: "Lasst uns sprechen.",
        sub: "Buche ein unverbindliches 30-Minuten-Gespräch. Wir hören zu, du bekommst einen konkreten Vorschlag für dein Team oder Unternehmen.",
        formTitle: "Anfrage für dein Unternehmen senden",
        investmentNote: "Konditionen werden individuell pro Auftrag besprochen. Rechnung erfolgt auf Firma (Kleinunternehmerregelung §19 UStG).",
      },
      legalNote: "Hinweis B2B: Für gewerbliche Kunden gilt kein Verbraucher-Widerrufsrecht. Konditionen werden in einem Auftrag schriftlich fixiert.",
    },
    contact: {
      name: "Name",
      email: "E-Mail",
      phone: "Telefon (optional)",
      message: "Worum geht es?",
      submit: "Anfrage senden",
      whatsapp: "WhatsApp",
      mail: "E-Mail",
      success: "Danke. Deine Anfrage ist angekommen. Wir melden uns persönlich.",
      error: "Es gab ein Problem. Bitte versuche es erneut.",
      placeholderMessage: "Schreib in zwei, drei Sätzen, was dich gerade bewegt.",
    },
    shop_actions: {
      buy: "Jetzt kaufen",
      checkout: "Zur Kasse",
      modal_name: "Name",
      modal_email: "E-Mail",
      modal_note: "Bezahlung über Stripe (SSL-verschlüsselt). Du erhältst den Download-Link direkt nach Bezahlung per E-Mail und auf der Erfolgsseite. Link 72 Std. gültig, bis zu 5 Downloads.",
      checkout_failed: "Checkout fehlgeschlagen",
      close: "Schließen",
    },
    footer: {
      built: "Enrico Müller & Colleen Schmidt · Green Horizon Life",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    legal: {
      placeholder: "Diese Seite ist ein Platzhalter. Die rechtlichen Inhalte werden hier in Kürze ergänzt.",
      lastUpdated: "Stand: Juni 2026",
      impressum: {
        title: "Impressum",
        intro: "Angaben gemäß § 5 TMG",
        sections: [
          {
            heading: "Anbieter",
            lines: [
              "Enrico Müller",
              "Personal Coach",
              "Rosenstraße 2",
              "97499 Geroldshofen",
              "Deutschland",
            ],
          },
          {
            heading: "Kontakt",
            lines: [
              "Telefon: +49 35116087387",
              "E-Mail: info@green-horizon-life.com",
            ],
          },
          {
            heading: "Umsatzsteuer",
            lines: [
              "Gemäß § 19 UStG wird keine Umsatzsteuer berechnet (Kleinunternehmerregelung).",
            ],
          },
          {
            heading: "Berufsbezeichnung",
            lines: [
              "Personal Coach (freiberuflich tätig)",
              "Verliehen in: Deutschland",
            ],
          },
          {
            heading: "Inhaltlich verantwortliche Partnerin",
            lines: [
              "Colleen Schmidt — systemische Beratung, Aufstellungsarbeit, spirituelle Begleitung",
              "Beiträge auf der Frauen-Seite sowie im B2B-Bereich verantwortet inhaltlich Colleen Schmidt gemeinsam mit Enrico Müller. Rechtlich verantwortlicher Diensteanbieter im Sinne des § 5 TMG bleibt Enrico Müller (siehe oben).",
            ],
          },
          {
            heading: "Hinweis für gewerbliche Kunden (B2B)",
            paragraphs: [
              "Für Verträge mit Unternehmern, juristischen Personen des öffentlichen Rechts oder öffentlich-rechtlichen Sondervermögen (B2B) gilt kein Verbraucher-Widerrufsrecht. Konditionen, Leistungsumfang und Zahlungsbedingungen werden individuell in einem schriftlichen Auftrag fixiert.",
            ],
          },
          {
            heading: "Redaktionell verantwortlich",
            lines: [
              "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV:",
              "Enrico Müller",
              "Rosenstraße 2, 97499 Geroldshofen",
            ],
          },
          {
            heading: "Streitschlichtung",
            paragraphs: [
              "Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr.",
              "Meine E-Mail-Adresse findest du oben im Impressum. Ich bin nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.",
            ],
          },
          {
            heading: "Haftung für Inhalte",
            paragraphs: [
              "Als Diensteanbieter bin ich gemäß § 7 Abs. 1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.",
              "Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werde ich diese Inhalte umgehend entfernen.",
            ],
          },
          {
            heading: "Haftung für Links",
            paragraphs: [
              "Mein Angebot enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte ich keinen Einfluss habe. Deshalb kann ich für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.",
              "Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werde ich derartige Links umgehend entfernen.",
            ],
          },
          {
            heading: "Urheberrecht",
            paragraphs: [
              "Die durch mich erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.",
            ],
          },
          {
            heading: "Hinweis zum Coaching",
            paragraphs: [
              "Coaching, Hypnose und Körpersprache-Training sind keine Heilbehandlung und ersetzen keinen Arzt oder Therapeuten. Die Inhalte dienen ausschließlich der persönlichen Entwicklung und Persönlichkeitsbildung. Bei medizinischen oder psychischen Beschwerden wende dich bitte an entsprechende Fachkräfte.",
            ],
          },
        ],
      },
      privacy: {
        title: "Datenschutzerklärung",
        intro: "Diese Datenschutzerklärung informiert dich über Art, Umfang und Zweck der Verarbeitung personenbezogener Daten (im Folgenden „Daten“) auf dieser Website. Verantwortlich im Sinne der DSGVO ist:",
        sections: [
          {
            heading: "1. Verantwortlicher",
            lines: [
              "Enrico Müller",
              "Rosenstraße 2",
              "97499 Geroldshofen",
              "Deutschland",
              "E-Mail: info@green-horizon-life.com",
              "Telefon: +49 35116087387",
            ],
          },
          {
            heading: "2. Erhebung allgemeiner Informationen (Server-Logfiles)",
            paragraphs: [
              "Beim Besuch dieser Website werden automatisch Informationen allgemeiner Natur erfasst (Browser-Typ, verwendetes Betriebssystem, Domainname der besuchenden Website, IP-Adresse, Datum und Uhrzeit des Zugriffs, übertragene Datenmenge). Diese Daten lassen keinen unmittelbaren Rückschluss auf deine Person zu.",
              "Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der technischen Bereitstellung und Sicherheit der Website). Die Daten werden nach spätestens 30 Tagen gelöscht, sofern keine sicherheitsrelevanten Ereignisse vorliegen.",
            ],
          },
          {
            heading: "3. Kontaktformular",
            paragraphs: [
              "Wenn du das Kontaktformular nutzt, werden die von dir eingegebenen Daten (Name, E-Mail-Adresse, ggf. Telefonnummer und Nachricht) zum Zweck der Bearbeitung deiner Anfrage gespeichert. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung eines Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Kommunikation).",
              "Die Daten werden gelöscht, sobald sie für den Zweck der Bearbeitung nicht mehr erforderlich sind, spätestens jedoch nach 24 Monaten. Gesetzliche Aufbewahrungspflichten bleiben unberührt.",
            ],
          },
          {
            heading: "4. E-Mail-Versand über Resend (USA)",
            paragraphs: [
              "Zum Versand der Bestätigungs- und Benachrichtigungs-E-Mails nutze ich den Dienst Resend (Resend, Inc., 2261 Market Street #4677, San Francisco, CA 94114, USA).",
              "Bei der Übermittlung an Resend werden deine E-Mail-Adresse, dein Name und der Nachrichteninhalt verarbeitet. Resend ist nach dem EU-US Data Privacy Framework zertifiziert; auf dieser Grundlage und einem mit Resend abgeschlossenen Auftragsverarbeitungsvertrag (Art. 28 DSGVO) erfolgt die Übermittlung in die USA rechtmäßig.",
              "Weitere Informationen: https://resend.com/legal/privacy-policy",
            ],
          },
          {
            heading: "5. Zahlungsabwicklung (Stripe)",
            paragraphs: [
              "Für Käufe im Shop nutze ich den Zahlungsdienstleister Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Irland.",
              "Bei einem Kauf werden deine Zahlungsdaten direkt an Stripe übermittelt und dort gemäß den Datenschutzrichtlinien von Stripe verarbeitet. Ich erhalte lediglich die Information, dass die Zahlung erfolgreich war, sowie deinen Namen und deine E-Mail-Adresse zur Lieferung des digitalen Produkts.",
              "Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung). Weitere Informationen: https://stripe.com/de/privacy",
            ],
          },
          {
            heading: "6. Hosting & Content Delivery (Cloudflare, Emergent)",
            paragraphs: [
              "Die Website wird über Cloudflare, Inc. (101 Townsend St, San Francisco, CA 94107, USA) ausgeliefert. Cloudflare verarbeitet IP-Adressen und technische Informationen zum Schutz vor Angriffen und zur Beschleunigung der Bereitstellung.",
              "Cloudflare ist nach dem EU-US Data Privacy Framework zertifiziert; ein Auftragsverarbeitungsvertrag liegt vor. Datenschutz: https://www.cloudflare.com/de-de/privacypolicy/",
              "Das Anwendungs-Hosting erfolgt über Emergent (Plattform für Web-Anwendungen). Daten aus dem Kontaktformular werden in einer Datenbank gespeichert, auf die ausschließlich ich Zugriff habe.",
            ],
          },
          {
            heading: "7. Cookies & Local Storage",
            paragraphs: [
              "Diese Website verwendet ausschließlich technisch notwendige Speichermechanismen (Local Storage), um deine Sprachpräferenz (Deutsch/Englisch) zu speichern. Es werden keine Tracking-Cookies, Analyse-Cookies oder Marketing-Cookies eingesetzt.",
              "Rechtsgrundlage: § 25 Abs. 2 TTDSG (technisch notwendige Speicherung).",
            ],
          },
          {
            heading: "8. Deine Rechte",
            paragraphs: [
              "Du hast jederzeit folgende Rechte hinsichtlich deiner personenbezogenen Daten:",
            ],
            bullets: [
              "Recht auf Auskunft (Art. 15 DSGVO)",
              "Recht auf Berichtigung (Art. 16 DSGVO)",
              "Recht auf Löschung (Art. 17 DSGVO)",
              "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
              "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
              "Widerspruchsrecht gegen die Verarbeitung (Art. 21 DSGVO)",
              "Recht auf Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)",
            ],
            paragraphsAfter: [
              "Wende dich für die Ausübung dieser Rechte formlos an info@green-horizon-life.com.",
            ],
          },
          {
            heading: "9. Beschwerderecht",
            paragraphs: [
              "Du hast das Recht, dich bei einer Aufsichtsbehörde zu beschweren. Für mich zuständig ist das Bayerische Landesamt für Datenschutzaufsicht (BayLDA), Promenade 18, 91522 Ansbach, https://www.lda.bayern.de.",
            ],
          },
          {
            heading: "10. Änderungen dieser Datenschutzerklärung",
            paragraphs: [
              "Ich behalte mir vor, diese Datenschutzerklärung anzupassen, damit sie stets aktuellen rechtlichen Anforderungen entspricht oder Änderungen meiner Leistungen widerspiegelt. Für deinen erneuten Besuch gilt dann die jeweils aktuelle Fassung.",
            ],
          },
        ],
      },
    },
  },
  en: {
    nav: {
      women: "Women",
      men: "Men",
      contact: "Contact",
      imprint: "Imprint",
      privacy: "Privacy",
      backHome: "Back to selection",
    },
    entry: {
      eyebrow: "Enrico Müller & Colleen Schmidt · Coaching",
      question: "Which path do we take together?",
      lead: "Choose your area for tailored coaching.",
      women: {
        eyebrow: "With Colleen",
        title: "Inner journey.",
        subtitle: "Clarity. Feminine power.",
        action: "Take this path",
      },
      men: {
        eyebrow: "With Enrico",
        title: "Mental strength.",
        subtitle: "Focus. Sovereignty.",
        action: "Take this path",
      },
      footer: "Confidential consultation · Hypnosis · Body language · Self-development",
    },
    stage: {
      eyebrow: "Enrico Müller & Colleen Schmidt",
      brand: "Green Horizon Life",
      question: "Who is ready to grow — you or your team?",
      lead: "One journey. Two worlds. Choose your path and discover what's ready to change for you.",
      privat: {
        eyebrow: "Personal",
        title: "For you personally.",
        subtitle: "Inner clarity, growth, self-development.",
        body: "Hypnosis, body language, systemic constellation work — for your very personal journey.",
        action: "Personal path",
      },
      business: {
        eyebrow: "Business",
        title: "For your company.",
        subtitle: "Workshops, team coaching, sales training.",
        body: "Mentally strong teams, sovereign leadership, clear sales closings — for companies and organizations.",
        action: "Business path",
      },
      footer: "Two coaches · One vision · Real growth",
    },
    women: {
      hero: {
        eyebrow: "With Colleen Schmidt · Systemic counselling, constellations & spirituality",
        title: "Discover your true self.",
        sub: "Are you ready for a journey to yourself? Together we dissolve blocks, heal old wounds and strengthen the connection to your inner child. Step by step you find your way back to your strength, your energy and the deepest wishes of your heart.",
        ctaPrimary: "Request a consultation",
        ctaSecondary: "Learn more",
      },
      problem: {
        eyebrow: "If this sounds like you",
        title: "You function, but something feels tight inside.",
        body: "Heavy family patterns, old fears, quiet beliefs — they keep you small even though you fulfil everything on the outside. When you're ready to accept yourself and live your life consciously, your journey begins here. Your new life is waiting for you.",
        bullets: [
          "Fears that keep coming back up.",
          "Family patterns that repeat themselves.",
          "A quiet sense that there's more inside you.",
          "A longing for clarity and connection.",
        ],
      },
      about: {
        eyebrow: "About Colleen",
        title: "Guidance with depth, mindfulness and clarity.",
        body: "With systemic counselling, constellation work, mindfulness, meditation and spiritual impulses, I support you in reconnecting with yourself and unfolding your full potential. I help you to release heavy family patterns, gain new clarity and rediscover your inner strength.",
        quote: "Your path begins with the first step — towards a life in harmony with your heart.",
      },
      pillars: {
        eyebrow: "Possible themes",
        title: "Themes of our work together.",
        items: [
          { id: "blockaden", title: "Blocks & beliefs", body: "We recognise and dissolve old beliefs, break through stuck patterns and create space for new clarity." },
          { id: "aufstellung", title: "Systemic constellations", body: "Family entanglements, relationships and life themes become visible — and can therefore start to move." },
          { id: "inneres-kind", title: "Inner child & spirituality", body: "Heal old wounds, strengthen your inner child and deepen your intuition through meditation and spiritual impulses." },
        ],
      },
      proof: {
        eyebrow: "What clients experience",
        items: [
          "After our constellation, what had bound me for years was suddenly clear. I finally feel free.",
          "Colleen creates a space where I could really arrive. Deep, calm, no pressure.",
          "My inner child was allowed to take up space for the first time. That changed everything.",
        ],
      },
      cta: {
        eyebrow: "Next step",
        title: "Start your journey.",
        sub: "Schedule your confidential consultation. Calm, no pressure, no obligation — a clear space for your topics.",
        formTitle: "Request a confidential consultation",
        investmentNote: "Investment and scope are discussed individually in the confidential consultation.",
      },
      shop: {
        eyebrow: "Companions in between",
        title: "Meditations, PDFs & more",
        sub: "Meditations, PDF guides and constellation instructions to replay and practice. Downloadable directly after purchase.",
      },
      bridge: {
        eyebrow: "Other paths",
        title: "Looking for something different?",
        body: "My partner Enrico Müller works with men on mental strength, body language and driver motivation. For companies, we together offer workshops, team coaching and sales training.",
        crossEyebrow: "Looking for the more demanding, focused approach?",
        crossLink: "Switch to the men's path",
      },
    },
    men: {
      hero: {
        eyebrow: "For men. Hypnosis, body language & driver-motivation",
        title: "Mental strength. Full focus. Absolute presence.",
        sub: "Break through the thought patterns blocking you. Use the power of hypnosis and razor-sharp body language to reclaim your full strength and sovereignty as a man.",
        ctaPrimary: "Secure your consultation",
        ctaSecondary: "How it works",
      },
      problem: {
        eyebrow: "Does this sound like you?",
        title: "You function, but you've stalled.",
        body: "On the outside things run. Numbers, responsibilities, calendar. And still: thoughts circling instead of clear decisions. Motivation slipping in sales. Presence that isn't unshakable in meetings anymore. You know you can do more, you just can't reach it.",
        bullets: [
          "Head full, decisions sluggish.",
          "Sales conversations that don't land anymore.",
          "Your presence works, but not as cleanly as you want.",
          "You don't need a pep talk. You need change in the subconscious.",
        ],
      },
      about: {
        eyebrow: "About me",
        title: "From the pressure of a pro kitchen into the mental high-performance zone.",
        body: "As a trained chef I learned in high-performance kitchens what focus, heat and clarity really mean. I sharpened my sales skill internationally, including intensive trainings in Italy, where sales isn't taught but lived. From this practice I know exactly what blocks men in sales and in their presence. And through my own brutal development I know how to dismantle mental blocks directly in the subconscious. Precisely, without fluff.",
        quote: "You don't need to get harder. You need to get clearer.",
      },
      pillars: {
        eyebrow: "Three pillars",
        title: "Three levers. Felt immediately.",
        items: [
          { id: "hypnose", title: "Men's hypnosis", body: "Eliminate blocks, directly in the subconscious. Beliefs that keep you small are precisely dismantled and replaced with new programming." },
          { id: "koerper", title: "Masculine body language", body: "Dominance & sovereignty that isn't put on. Stance, voice, gaze. In sales, in meetings, in the room." },
          { id: "motivation", title: "Driver-motivation", body: "Focus and pro-level sales training. You leave with clear goals, clear sentences and a mental setup that holds." },
        ],
      },
      proof: {
        eyebrow: "What clients report",
        items: [
          "After three sessions, what had blocked me for two years was simply gone.",
          "My closing rate went up. But more importantly: I'm fully in the room again.",
          "No fluff. Clear, precise, effective. Exactly what I needed.",
        ],
      },
      cta: {
        eyebrow: "Next step",
        title: "Secure your consultation now.",
        sub: "Out of your head, into success. We talk for 30 minutes, clear, direct, no sales pressure. You leave with a concrete next step.",
        formTitle: "Request your consultation",
        investmentNote: "Investment and scope are discussed individually in the consultation.",
      },
      shop: {
        eyebrow: "Tools",
        title: "Ready to use. Immediately effective.",
        sub: "Audio sessions, PDFs and videos that keep working between our talks. Instant download after payment.",
      },
      bridge: {
        eyebrow: "Also depth & emotion",
        title: "The strongest men are the ones who can do both.",
        body: "Mental strength doesn't mean being without emotion. Real sovereignty arises when you also master deep relaxation, self-reflection and emotional clarity, not just performance. Whoever is stable inside dominates outside more calmly and sustainably.",
        crossEyebrow: "Looking for the calmer, deeper approach?",
        crossLink: "Switch to the women's path",
      },
    },
    business: {
      hero: {
        eyebrow: "For companies · Workshops, team coaching & sales training",
        title: "Mental strength. Clear communication. Tangible results.",
        sub: "Together, Enrico Müller & Colleen Schmidt support companies and teams in becoming mentally resilient, communicatively precise and sovereign in their presence — inside and out.",
        ctaPrimary: "Request a free consultation",
        ctaSecondary: "See services",
      },
      offers: {
        eyebrow: "Services",
        title: "What we offer for companies.",
        items: [
          { id: "workshops", title: "Company workshops", body: "Hypnosis, body language and mindset workshops for employees. In-house, compact, with measurable results." },
          { id: "team", title: "Team coaching & leadership", body: "Coaching for executives and entire teams: clarity in communication, conflict work, sovereign presence." },
          { id: "stress", title: "Resilience & stress prevention", body: "Mental resilience, deep relaxation and mindfulness for employees — prevents burnouts, lifts performance." },
          { id: "verkauf", title: "B2B sales training", body: "Sales at a professional level: conversation guidance, closing techniques, body language in sales conversations." },
          { id: "retreats", title: "Retreats for entrepreneurs", body: "Multi-day spiritual retreats for the self-employed, founders and leadership personalities." },
          { id: "aufstellung", title: "Systemic constellations in a business context", body: "Strategic clarity about structures, roles and conflicts through constellation work." },
        ],
      },
      duo: {
        eyebrow: "Your coaches",
        title: "Enrico Müller & Colleen Schmidt — complementary strengths.",
        body: "Enrico brings mental clarity, body language and high-performance mindset. Colleen complements with systemic depth, constellation work and emotional intelligence. Together we cover the full range — from performance to personality.",
      },
      cta: {
        eyebrow: "Next step",
        title: "Let's talk.",
        sub: "Book a free 30-minute call. We listen, and you get a concrete proposal for your team or company.",
        formTitle: "Send a request for your company",
        investmentNote: "Conditions are discussed individually per assignment. Invoicing to the company (small business regulation §19 UStG).",
      },
      legalNote: "B2B notice: For business clients, no consumer right of withdrawal applies. Conditions are set out in a written contract.",
    },
    contact: {
      name: "Name",
      email: "Email",
      phone: "Phone (optional)",
      message: "What's on your mind?",
      submit: "Send request",
      whatsapp: "WhatsApp",
      mail: "Email",
      success: "Thank you. Your request has been received. We will personally get back to you.",
      error: "Something went wrong. Please try again.",
      placeholderMessage: "Write in two or three sentences what is currently going on.",
    },
    shop_actions: {
      buy: "Buy now",
      checkout: "Go to checkout",
      modal_name: "Name",
      modal_email: "Email",
      modal_note: "Payment via Stripe (SSL-encrypted). You receive the download link directly after payment via email and on the success page. Link valid 72 h, up to 5 downloads.",
      checkout_failed: "Checkout failed",
      close: "Close",
    },
    footer: {
      built: "Enrico Müller & Colleen Schmidt · Green Horizon Life",
      imprint: "Imprint",
      privacy: "Privacy",
    },
    legal: {
      placeholder: "This page is a placeholder. The legal content will be added here shortly.",
      lastUpdated: "Last updated: June 2026",
      impressum: {
        title: "Imprint",
        intro: "Information according to § 5 TMG (German Telemedia Act)",
        sections: [
          {
            heading: "Provider",
            lines: [
              "Enrico Müller",
              "Personal Coach",
              "Rosenstraße 2",
              "97499 Geroldshofen",
              "Germany",
            ],
          },
          {
            heading: "Contact",
            lines: [
              "Phone: +49 35116087387",
              "E-mail: info@green-horizon-life.com",
            ],
          },
          {
            heading: "VAT",
            lines: [
              "Pursuant to § 19 UStG (small business regulation), no VAT is charged.",
            ],
          },
          {
            heading: "Professional title",
            lines: [
              "Personal Coach (self-employed)",
              "Granted in: Germany",
            ],
          },
          {
            heading: "Content Partner",
            lines: [
              "Colleen Schmidt — systemic counselling, constellation work, spiritual guidance",
              "Content on the women's page and the B2B section is curated jointly by Colleen Schmidt and Enrico Müller. The legally responsible service provider within the meaning of § 5 TMG remains Enrico Müller (see above).",
            ],
          },
          {
            heading: "Notice for business clients (B2B)",
            paragraphs: [
              "For contracts with entrepreneurs, legal entities under public law, or special funds under public law (B2B), the consumer right of withdrawal does not apply. Conditions, scope of services, and payment terms will be set out individually in a written agreement.",
            ],
          },
          {
            heading: "Responsible for content",
            lines: [
              "Responsible for content according to § 18 (2) MStV:",
              "Enrico Müller",
              "Rosenstraße 2, 97499 Geroldshofen, Germany",
            ],
          },
          {
            heading: "Dispute resolution",
            paragraphs: [
              "The European Commission provides a platform for online dispute resolution (ODR): https://ec.europa.eu/consumers/odr.",
              "My e-mail address can be found above. I am neither willing nor obliged to participate in dispute resolution proceedings before a consumer arbitration board.",
            ],
          },
          {
            heading: "Liability for content",
            paragraphs: [
              "As a service provider, I am responsible for my own content on these pages under general law in accordance with § 7 (1) TMG. According to §§ 8 to 10 TMG, however, I am not obligated as a service provider to monitor third-party information transmitted or stored on these pages or to investigate circumstances that indicate illegal activity.",
              "Obligations to remove or block the use of information under general laws remain unaffected. Liability in this respect, however, is only possible from the time of knowledge of a specific legal violation. Upon notification of any such violations, I will remove the content immediately.",
            ],
          },
          {
            heading: "Liability for links",
            paragraphs: [
              "My offer may contain links to external third-party websites whose content I have no influence over. Therefore I cannot assume any liability for these external contents. The respective provider or operator of the linked pages is always responsible for their content.",
              "Permanent monitoring of the linked pages is not reasonable without concrete evidence of a legal violation. Upon notification of any such violations, I will remove such links immediately.",
            ],
          },
          {
            heading: "Copyright",
            paragraphs: [
              "The content and works created by me on these pages are subject to German copyright law. Duplication, processing, distribution, or any form of commercialization beyond the scope of copyright law requires the written consent of the respective author. Downloads and copies of this site are only permitted for private, non-commercial use.",
            ],
          },
          {
            heading: "Note on coaching",
            paragraphs: [
              "Coaching, hypnosis, and body language training are not medical treatments and do not replace a doctor or therapist. The contents serve exclusively the purpose of personal development and personality building. For medical or psychological complaints, please consult appropriate specialists.",
            ],
          },
        ],
      },
      privacy: {
        title: "Privacy Policy",
        intro: "This privacy policy informs you about the nature, scope, and purpose of the processing of personal data (hereinafter \"data\") on this website. The data controller within the meaning of the GDPR is:",
        sections: [
          {
            heading: "1. Data Controller",
            lines: [
              "Enrico Müller",
              "Rosenstraße 2",
              "97499 Geroldshofen",
              "Germany",
              "E-mail: info@green-horizon-life.com",
              "Phone: +49 35116087387",
            ],
          },
          {
            heading: "2. Server log files",
            paragraphs: [
              "When you visit this website, general information is automatically collected (browser type, operating system used, domain name of the visiting website, IP address, date and time of access, amount of data transferred). This data does not allow any direct conclusions to be drawn about you personally.",
              "Processing is based on Art. 6 (1) lit. f GDPR (legitimate interest in technical provision and security of the website). The data is deleted after 30 days at the latest, unless security-related events require longer storage.",
            ],
          },
          {
            heading: "3. Contact form",
            paragraphs: [
              "When you use the contact form, the data you enter (name, e-mail address, phone number if provided, and message) is stored for the purpose of processing your request. The legal basis is Art. 6 (1) lit. b GDPR (initiation of a contract) or Art. 6 (1) lit. f GDPR (legitimate interest in communication).",
              "The data will be deleted as soon as it is no longer necessary for the purpose of processing, but no later than 24 months. Statutory retention periods remain unaffected.",
            ],
          },
          {
            heading: "4. E-mail delivery via Resend (USA)",
            paragraphs: [
              "For sending confirmation and notification e-mails, I use the service Resend (Resend, Inc., 2261 Market Street #4677, San Francisco, CA 94114, USA).",
              "When transmitting to Resend, your e-mail address, name, and message content are processed. Resend is certified under the EU-US Data Privacy Framework; on this basis and a data processing agreement (Art. 28 GDPR) concluded with Resend, the transfer to the USA is lawful.",
              "More information: https://resend.com/legal/privacy-policy",
            ],
          },
          {
            heading: "5. Payment processing (Stripe)",
            paragraphs: [
              "For purchases in the shop, I use the payment service provider Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin, Ireland.",
              "When you make a purchase, your payment data is transferred directly to Stripe and processed there in accordance with Stripe's privacy policy. I only receive the information that the payment was successful, as well as your name and e-mail address for the delivery of the digital product.",
              "Legal basis: Art. 6 (1) lit. b GDPR (performance of contract). More information: https://stripe.com/privacy",
            ],
          },
          {
            heading: "6. Hosting & Content Delivery (Cloudflare, Emergent)",
            paragraphs: [
              "The website is delivered via Cloudflare, Inc. (101 Townsend St, San Francisco, CA 94107, USA). Cloudflare processes IP addresses and technical information to protect against attacks and to accelerate delivery.",
              "Cloudflare is certified under the EU-US Data Privacy Framework; a data processing agreement is in place. Privacy: https://www.cloudflare.com/privacypolicy/",
              "Application hosting is provided via Emergent (a web application platform). Data from the contact form is stored in a database which I alone can access.",
            ],
          },
          {
            heading: "7. Cookies & Local Storage",
            paragraphs: [
              "This website uses only technically necessary storage mechanisms (local storage) to remember your language preference (German/English). No tracking cookies, analytics cookies, or marketing cookies are used.",
              "Legal basis: § 25 (2) TTDSG (technically necessary storage).",
            ],
          },
          {
            heading: "8. Your rights",
            paragraphs: [
              "You have the following rights at any time regarding your personal data:",
            ],
            bullets: [
              "Right of access (Art. 15 GDPR)",
              "Right to rectification (Art. 16 GDPR)",
              "Right to erasure (Art. 17 GDPR)",
              "Right to restriction of processing (Art. 18 GDPR)",
              "Right to data portability (Art. 20 GDPR)",
              "Right to object to processing (Art. 21 GDPR)",
              "Right to withdraw consent (Art. 7 (3) GDPR)",
            ],
            paragraphsAfter: [
              "To exercise these rights, please contact info@green-horizon-life.com informally.",
            ],
          },
          {
            heading: "9. Right to lodge a complaint",
            paragraphs: [
              "You have the right to lodge a complaint with a supervisory authority. The competent authority for me is the Bavarian State Office for Data Protection Supervision (BayLDA), Promenade 18, 91522 Ansbach, https://www.lda.bayern.de.",
            ],
          },
          {
            heading: "10. Changes to this Privacy Policy",
            paragraphs: [
              "I reserve the right to amend this Privacy Policy to ensure it always complies with current legal requirements or to reflect changes in my services. The current version will apply on your next visit.",
            ],
          },
        ],
      },
    },
  },
};
